import React, { useEffect, useState } from 'react';
import {
    Row, Col, Card, Typography, Space, Avatar,
    Tag, Badge, Divider, Empty, Spin, notification
} from 'antd';
import {
    TeamOutlined,
    PhoneOutlined,
    UserOutlined,
    SafetyCertificateOutlined
} from '@ant-design/icons';
import axiosClient from '../../api/axiosClient';

const { Title, Text } = Typography;

const MemberTrainers = () => {
    const [loading, setLoading] = useState(true);
    const [trainers, setTrainers] = useState([]);

    useEffect(() => {
        fetchTrainers();
    }, []);

    const fetchTrainers = async () => {
        setLoading(true);
        try {
            const response = await axiosClient.get('/portal/get_assigned_trainers.php');
            if (response.data.status === 'success') {
                setTrainers(response.data.data || []);
            } else {
                notification.error({ message: "Error", description: response.data.message });
            }
        } catch (error) {
            console.error("Fetch trainers error:", error);
            notification.error({ message: "Error", description: "Failed to load assigned trainers." });
        } finally {
            setLoading(false);
        }
    };

    const glassStyle = {
        borderRadius: 20,
        border: 'none',
        boxShadow: '0 8px 32px rgba(0,0,0,0.05)',
        background: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(10px)'
    };

    return (
        <Spin spinning={loading} tip="Loading trainers...">
            <div style={{ width: '100%', paddingBottom: 40 }}>
                <Title level={2} style={{ color: '#1a1a1a', fontWeight: 800, marginBottom: 8, fontFamily: "'Inter', sans-serif" }}>
                    My Trainers 👟
                </Title>
                <p style={{ color: '#666', fontSize: 16, marginBottom: 32 }}>
                    These are the professional trainers assigned to guide your fitness journey.
                </p>

                {trainers.length > 0 ? (
                    <Row gutter={[24, 24]}>
                        {trainers.map((trainer) => (
                            <Col xs={24} sm={12} lg={8} key={trainer.id}>
                                <Card
                                    style={glassStyle}
                                    bodyStyle={{ padding: 24 }}
                                >
                                    <div style={{ textAlign: 'center', marginBottom: 20 }}>
                                        <Avatar
                                            size={80}
                                            style={{
                                                backgroundColor: '#722ed1',
                                                marginBottom: 12,
                                                boxShadow: '0 4px 12px rgba(114, 46, 209, 0.2)'
                                            }}
                                        >
                                            {trainer.name?.charAt(0)?.toUpperCase()}
                                        </Avatar>
                                        <Title level={4} style={{ margin: 0 }}>{trainer.name}</Title>
                                        <Text type="secondary" style={{ fontSize: 12 }}>ID: {trainer.trainer_id}</Text>
                                    </div>

                                    <Divider style={{ margin: '12px 0' }} />

                                    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                                        {trainer.specialization && (
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Text type="secondary"><Space size={4}><SafetyCertificateOutlined /> Specialization</Space></Text>
                                                <Tag color="purple" style={{ borderRadius: 8, margin: 0 }}>{trainer.specialization}</Tag>
                                            </div>
                                        )}
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Text type="secondary"><Space size={4}><PhoneOutlined /> Contact</Space></Text>
                                            <Text strong>{trainer.contact_no || 'N/A'}</Text>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Text type="secondary"><Space size={4}><UserOutlined /> Status</Space></Text>
                                            <Badge
                                                status={trainer.status ? 'success' : 'error'}
                                                text={<Text strong>{trainer.status ? 'Active' : 'Inactive'}</Text>}
                                            />
                                        </div>
                                    </Space>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                ) : (
                    <Card style={glassStyle}>
                        <Empty
                            description="No trainers assigned to you yet. Contact the gym management to get a trainer assigned."
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                        />
                    </Card>
                )}
            </div>
        </Spin>
    );
};

export default MemberTrainers;
